module.exports = __webpack_public_path__ + "img/step1.90c2de3a.png";